import { CardsConfig, FontWeight } from '@rappider/rappider-components/utils';
import { IconType, HeadingType, ButtonSize, NgZorroIconTheme } from '@rappider/rappider-components/utils';
import { ItemPerRow } from 'libs/components/src/lib/utils/card-one-list';
import { SelectMode } from 'libs/components/src/lib/utils/select';
import { AIGenerationType } from '../../../../ai-integration/src/lib/utils/ai-response-types.interface';

export const pageCardsConfig: { cardsConfig: CardsConfig } = {
  cardsConfig: {
    itemCountPerRow: ItemPerRow.Two,
    showTitleOnImage: false,
    showDescriptionOnImage: false,
    showCheckMarkOnCard: false,
    paginationConfig: {
      pageIndex: 1,
      total: 3,
      pageSize: 6,
      showPagination: false,
      nzFrontPagination: false
    },
    selectConfig: {
      options: [],
      settings: {
        mode: SelectMode.Multiple,
        maxTagCount: 1
      },
      placeholder: 'Filter Tags',
      visibility: false
    },
    items: [],
    inputGroupConfig: {
      textbox: {
        placeholder: 'Search in Pages',
      },
      suffixIcon: {
        name: 'fas fa-xmark',
        type: IconType.FontAwesome,
        isClickable: true
      }
    },
    topCards: [
      {
        data: { id: 'blank-page', type: 'create-blank-page' },
        titles: [
          {
            type: HeadingType.H1,
            content: '<i class="fa-solid fa-plus primary-color-icon" style="color: var(--primary-color) !important;"></i>',

          },
          {
            type: HeadingType.H4,
            content: 'Create Blank Page',

          }
        ],
        descriptions: [
          {
            content: 'Start with a clean slate and design your page from scratch with full customization options',
            typography: {
              fontSize: 'var(--subtext-font-size)',
              whiteSpace: 'pre-wrap'
            }
          }
        ]
      },
      {
        data: { id: 'ai-page', type: 'create-ai-page' },
        titles: [
          {
            type: HeadingType.H1,
            content: '<i class="fa-solid fa-sparkles primary-color-icon" style="color: var(--primary-color) !important;"></i>',

          },
          {
            type: HeadingType.H4,
            content: 'Create Page with Assistant',

          }
        ],
        descriptions: [
          {
            content: 'Leverage AI to quickly generate a professional page based on your requirements and specifications',
            typography: {
              fontSize: 'var(--subtext-font-size)',
              whiteSpace: 'pre-wrap'
            }
          }
        ],
      },

    ],
    topCardsItemCountPerRow: ItemPerRow.Two,
  }
};

export const layoutCardsConfig: { cardsConfig: CardsConfig } = {
  cardsConfig: {
    itemCountPerRow: ItemPerRow.Two,
    showTitleOnImage: false,
    showDescriptionOnImage: false,
    showCheckMarkOnCard: true,
    paginationConfig: {
      pageIndex: 1,
      total: 3,
      pageSize: 6,
      showPagination: false,
      nzFrontPagination: false
    },
    selectConfig: {
      options: [],
      settings: {
        mode: SelectMode.Multiple,
        maxTagCount: 1
      },
      placeholder: 'Filter Tags',
      visibility: false
    },
    items: [],
    inputGroupConfig: {
      textbox: {
        placeholder: 'Search in Layouts',
      },
      suffixIcon: {
        name: 'fas fa-xmark',
        type: IconType.FontAwesome,
        isClickable: true
      }
    },
    topCards: [
      {
        data: { id: 'blank-layout', type: 'create-blank-layout' },
        titles: [
          {
            type: HeadingType.H1,
            content: '<i class="fa-solid fa-plus primary-color-icon" style="color: var(--primary-color) !important;"></i>',

          },
          {
            type: HeadingType.H4,
            content: 'Create Layout',

          }
        ],
        descriptions: [
          {
            content: 'Start with a clean slate and design your layout from scratch with full customization options',
            typography: {
              fontSize: 'var(--subtext-font-size)',
              whiteSpace: 'pre-wrap'
            }
          }
        ]
      },
      {
        data: { id: 'ai-layout', type: 'create-ai-layout' },
        titles: [
          {
            type: HeadingType.H1,
            content: '<i class="fa-solid fa-sparkles primary-color-icon" style="color: var(--primary-color) !important;"></i>',

          },
          {
            type: HeadingType.H4,
            content: 'Create Layout with Assistant',

          }
        ],
        descriptions: [
          {
            content: 'Leverage AI to quickly generate a professional layout based on your requirements and specifications',
            typography: {
              fontSize: 'var(--subtext-font-size)',
              whiteSpace: 'pre-wrap'
            }
          }
        ],
        disabledCard: true,
        cardTooltipContent: 'Create Layout with AI Assistant feature is not available for free plan users. Please upgrade your plan to use this feature.'
      }
    ],
    topCardsItemCountPerRow: ItemPerRow.Two,
  }
};

export const themeCardsConfig: { cardsConfig: CardsConfig } = {
  cardsConfig: {
    itemCountPerRow: ItemPerRow.Two,
    showTitleOnImage: false,
    showDescriptionOnImage: false,
    showCheckMarkOnCard: true,
    paginationConfig: {
      pageIndex: 1,
      total: 3,
      pageSize: 6,
      showPagination: false,
      nzFrontPagination: false
    },
    selectConfig: {
      options: [],
      settings: {
        mode: SelectMode.Multiple,
        maxTagCount: 1
      },
      placeholder: 'Filter Tags',
      visibility: false
    },
    items: [],
    inputGroupConfig: {
      textbox: {
        placeholder: 'Search in Themes',
      },
      suffixIcon: {
        name: 'fas fa-xmark',
        type: IconType.FontAwesome,
        isClickable: true
      }
    },
    topCards: [
      {
        data: { id: 'blank-theme', type: 'create-blank-theme' },
        titles: [
          {
            type: HeadingType.H1,
            content: '<i class="fa-solid fa-plus primary-color-icon" style="color: var(--primary-color) !important;"></i>',

          },
          {
            type: HeadingType.H4,
            content: 'Create Theme',

          }
        ],
        descriptions: [
          {
            content: 'Start with a clean slate and design your theme from scratch with full customization options',
            typography: {
              fontSize: 'var(--subtext-font-size)',
              whiteSpace: 'pre-wrap'
            }
          }
        ]
      },
      {
        data: { id: 'ai-theme', type: 'create-ai-theme' },
        titles: [
          {
            type: HeadingType.H1,
            content: '<i class="fa-solid fa-sparkles primary-color-icon" style="color: var(--primary-color) !important;"></i>',

          },
          {
            type: HeadingType.H4,
            content: 'Create Theme with Assistant',

          }
        ],
        descriptions: [
          {
            content: 'Leverage AI to quickly generate a professional theme based on your requirements and specifications',
            typography: {
              fontSize: 'var(--subtext-font-size)',
              whiteSpace: 'pre-wrap'
            }
          }
        ]
      }
    ],
    topCardsItemCountPerRow: ItemPerRow.Two,
  }
};

export const projectVersionCardsConfig: { cardsConfig: CardsConfig } = {
  cardsConfig: {
    itemCountPerRow: ItemPerRow.Two,
    showTitleOnImage: false,
    showDescriptionOnImage: false,
    showCheckMarkOnCard: false,
    paginationConfig: {
      pageIndex: 1,
      total: 3,
      pageSize: 6,
      showPagination: false,
      nzFrontPagination: false
    },
    selectConfig: {
      options: [],
      settings: {
        mode: SelectMode.Multiple,
        maxTagCount: 1
      },
      placeholder: 'Filter Tags',
      visibility: false
    },
    items: [],
    inputGroupConfig: {
      textbox: {
        placeholder: 'Search in Versions',
      },
      suffixIcon: {
        name: 'fas fa-xmark',
        type: IconType.FontAwesome,
        isClickable: true
      }
    },
    topCards: [
      {
        data: { id: 'blank-version', type: 'create-blank-version' },
        titles: [
          {
            type: HeadingType.H1,
            content: '<i class="fa-solid fa-plus primary-color-icon" style="color: var(--primary-color) !important;"></i>',

          },
          {
            type: HeadingType.H4,
            content: 'Create New Version',

          }
        ],
        descriptions: [
          {
            content: 'Start with a clean slate and create a new project version from scratch with full customization options',
            typography: {
              fontSize: 'var(--subtext-font-size)',
              whiteSpace: 'pre-wrap'
            }
          }
        ]
      }
    ],
    topCardsItemCountPerRow: ItemPerRow.Two,
  }
};

export const dataModelCardsConfig: { cardsConfig: CardsConfig } = {
  cardsConfig: {
    itemCountPerRow: ItemPerRow.Two,
    showTitleOnImage: false,
    showDescriptionOnImage: false,
    showCheckMarkOnCard: false,
    paginationConfig: {
      pageIndex: 1,
      total: 3,
      pageSize: 6,
      showPagination: false,
      nzFrontPagination: false
    },
    selectConfig: {
      options: [],
      settings: {
        mode: SelectMode.Multiple,
        maxTagCount: 1
      },
      placeholder: 'Filter Tags',
      visibility: false
    },
    items: [],
    inputGroupConfig: {
      textbox: {
        placeholder: 'Search in Data Models',
      },
      suffixIcon: {
        name: 'fas fa-xmark',
        type: IconType.FontAwesome,
        isClickable: true
      }
    },
    topCards: [
      {
        data: { id: 'blank-data-model', type: 'create-blank-data-model' },
        titles: [
          {
            type: HeadingType.H1,
            content: '<i class="fa-solid fa-plus primary-color-icon" style="color: var(--primary-color) !important;"></i>',

          },
          {
            type: HeadingType.H4,
            content: 'Create Data Model',

          }
        ],
        descriptions: [
          {
            content: 'Start with a clean slate and design your data model from scratch with full customization options',
            typography: {
              fontSize: 'var(--subtext-font-size)',
              whiteSpace: 'pre-wrap'
            }
          }
        ]
      },
      {
        data: { id: 'ai-data-model', type: AIGenerationType.DATA_MODEL },
        titles: [
          {
            type: HeadingType.H1,
            content: '<i class="fa-solid fa-sparkles primary-color-icon" style="color: var(--primary-color) !important;"></i>',

          },
          {
            type: HeadingType.H4,
            content: 'Create Data Model with Assistant',

          }
        ],
        descriptions: [
          {
            content: 'Leverage AI to quickly generate a professional data model based on your requirements and specifications',
            typography: {
              fontSize: 'var(--subtext-font-size)',
              whiteSpace: 'pre-wrap'
            }
          }
        ]
      }
    ],
    topCardsItemCountPerRow: ItemPerRow.Two,
  }
};

export const messageTemplatesCardsConfig: { cardsConfig: CardsConfig } = {
  cardsConfig: {
    itemCountPerRow: ItemPerRow.Two,
    showTitleOnImage: false,
    showDescriptionOnImage: false,
    showCheckMarkOnCard: false,
    paginationConfig: {
      pageIndex: 1,
      total: 3,
      pageSize: 6,
      showPagination: false,
      nzFrontPagination: false
    },
    selectConfig: {
      options: [],
      settings: {
        mode: SelectMode.Multiple,
        maxTagCount: 1
      },
      placeholder: 'Filter Tags',
      visibility: false
    },
    items: [],
    inputGroupConfig: {
      textbox: {
        placeholder: 'Search in Message Templates',
      },
      suffixIcon: {
        name: 'fas fa-xmark',
        isClickable: true,
        type: IconType.FontAwesome,
      }
    },
    topCards: [
      {
        data: { id: 'blank-template', type: 'create-blank-template' },
        titles: [
          {
            type: HeadingType.H1,
            content: '<i class="fa-solid fa-plus primary-color-icon" style="color: var(--primary-color) !important;"></i>',

          },
          {
            type: HeadingType.H4,
            content: 'Create Blank Template',

          }
        ],
        descriptions: [
          {
            content: 'Start with a clean slate and design your message template from scratch with full customization options',
            typography: {
              fontSize: 'var(--subtext-font-size)',
              whiteSpace: 'pre-wrap'
            }
          }
        ]
      },
      {
        data: { id: 'ai-template', type: 'create-ai-message-template' },
        titles: [
          {
            type: HeadingType.H1,
            content: '<i class="fa-solid fa-sparkles primary-color-icon" style="color: var(--primary-color) !important;"></i>',

          },
          {
            type: HeadingType.H4,
            content: 'Create Template with Assistant',

          }
        ],
        descriptions: [
          {
            content: 'Leverage AI to quickly generate professional message templates based on your requirements and specifications',
            typography: {
              fontSize: 'var(--subtext-font-size)',
              whiteSpace: 'pre-wrap'
            }
          }
        ],
        // cardTooltipPlacement?: string;
      }
    ],
    topCardsItemCountPerRow: ItemPerRow.Two,
  }
};

export const endpointsCardsConfig: { cardsConfig: CardsConfig } = {
  cardsConfig: {
    itemCountPerRow: ItemPerRow.Two,
    showTitleOnImage: false,
    showDescriptionOnImage: false,
    showCheckMarkOnCard: false,
    paginationConfig: {
      pageIndex: 1,
      total: 3,
      pageSize: 6,
      showPagination: false,
      nzFrontPagination: false
    },
    selectConfig: {
      options: [],
      settings: {
        mode: SelectMode.Multiple,
        maxTagCount: 1
      },
      placeholder: 'Filter Tags',
      visibility: false
    },
    items: [],
    inputGroupConfig: {
      textbox: {
        placeholder: 'Search in Endpoints',
      },
      suffixIcon: {
        name: 'fas fa-xmark',
        isClickable: true,
        type: IconType.FontAwesome,
      }
    },
    topCards: [
      {
        data: { id: 'ai-endpoint', type: 'create-ai-endpoint' },
        titles: [
          {
            type: HeadingType.H1,
            content: '<i class="fa-solid fa-sparkles primary-color-icon" style="color: var(--primary-color) !important;"></i>',

          },
          {
            type: HeadingType.H4,
            content: 'Create Endpoint with Assistant',

          }
        ],
        descriptions: [
          {
            content: 'Leverage AI to quickly generate professional Endpoints based on your requirements and specifications',
            typography: {
              fontSize: 'var(--subtext-font-size)',
              whiteSpace: 'pre-wrap'
            }
          }
        ],
        // cardTooltipPlacement?: string;
      }
    ],
    topCardsItemCountPerRow: ItemPerRow.Two,
  }
};

export const projectSettingsCardsConfig: { cardsConfig: CardsConfig } = {
  cardsConfig: {
    itemCountPerRow: ItemPerRow.Two,
    showTitleOnImage: false,
    showDescriptionOnImage: false,
    showCheckMarkOnCard: false,
    paginationConfig: {
      pageIndex: 1,
      total: 3,
      pageSize: 6,
      showPagination: false,
      nzFrontPagination: false
    },
    selectConfig: {
      options: [],
      settings: {
        mode: SelectMode.Multiple,
        maxTagCount: 1
      },
      placeholder: 'Filter Tags',
      visibility: false
    },
    items: [
      {
        data: { id: 'system-settings', type: 'project-setting' },
        titles: [
          {
            type: HeadingType.H4,
            content: 'System Settings'
          }
        ],
        descriptions: [
          {
            typography: {
              fontSize: 'var(--subtext-font-size)'
            },
            content: 'Configure system-level settings and configurations for your project'
          }
        ],
        isTooltipEnabledOnDescription: true,
        image: {
          source: 'assets/img/page-templates/profile-template1-thumbnail.png'
        },
        imageTags: [{}],
        imageButtons: [
          {
            key: 'preview-code',
            icon: { name: 'far fa-code', size: 'var(--card-icon-size)' },
            customColorSettings: {
              backgroundColor: 'var(--section-background-color)',
              color: 'var(--text-color)'
            },
            shadowSettings: {
              boxShadow: '0 0 0 var(--section-background-color)'
            },
            borderSettings: {
              border: 'var(--border-size-x)',
              borderColor: 'var(--secondary-border-color)',
              borderRadius: 'var(--border-radius-5x)'
            },
            size: ButtonSize.Default,
            tooltipText: 'Preview Code'
          }
        ]
      },
      {
        data: { id: 'custom-settings', type: 'custom-settings' },
        titles: [
          {
            type: HeadingType.H4,
            content: 'Custom Settings'
          }
        ],
        descriptions: [
          {
            typography: {
              fontSize: 'var(--subtext-font-size)'
            },
            content: 'Manage custom settings and configurations specific to your project requirements'
          }
        ],
        isTooltipEnabledOnDescription: true,
        image: {
          source: 'assets/img/page-templates/profile-template1-thumbnail.png'
        },
        imageTags: [{}]
      }
    ],
    inputGroupConfig: {
      textbox: {
        placeholder: 'Search in Project Settings',
      },
      suffixIcon: {
        name: 'fas fa-xmark',
        isClickable: true,
        type: IconType.FontAwesome,
      }
    },
    showSearchSection: false,
    titleText: {
      text: 'Project Settings',
      typography: {
        fontWeight: FontWeight.Bold,
        fontSize: 'var(--title-font-size)'
      }
    }
  }
};

export const projectEnvironmentCardsConfig: { cardsConfig: CardsConfig } = {
  cardsConfig: {
    itemCountPerRow: ItemPerRow.Two,
    showTitleOnImage: false,
    showDescriptionOnImage: false,
    showCheckMarkOnCard: false,
    paginationConfig: {
      pageIndex: 1,
      total: 3,
      pageSize: 6,
      showPagination: false,
      nzFrontPagination: false
    },
    selectConfig: {
      options: [],
      settings: {
        mode: SelectMode.Multiple,
        maxTagCount: 1
      },
      placeholder: 'Filter Tags',
      visibility: false
    },
    items: [],
    inputGroupConfig: {
      textbox: {
        placeholder: 'Search in Environment Variables',
      },
      suffixIcon: {
        name: 'fas fa-xmark',
        isClickable: true,
        type: IconType.FontAwesome,
      }
    },
    titleText: {
      text: 'Environment Variables',
      typography: {
        fontWeight: FontWeight.Bold,
        fontSize: 'var(--title-font-size)'
      }
    },
    showSearchSection: false
  }
};

export const uiDataStoreCardsConfig: { cardsConfig: CardsConfig } = {
  cardsConfig: {
    itemCountPerRow: ItemPerRow.Two,
    showTitleOnImage: false,
    showDescriptionOnImage: false,
    showCheckMarkOnCard: false,
    paginationConfig: {
      pageIndex: 1,
      total: 3,
      pageSize: 6,
      showPagination: false,
      nzFrontPagination: false
    },
    selectConfig: {
      options: [],
      settings: {
        mode: SelectMode.Multiple,
        maxTagCount: 1
      },
      placeholder: 'Filter Tags',
      visibility: false
    },
    items: [],
    inputGroupConfig: {
      textbox: {
        placeholder: 'Search in Data Stores',
      },
      suffixIcon: {
        name: 'fas fa-xmark',
        isClickable: true,
        type: IconType.FontAwesome,
      }
    },
    topCards: [
      {
        data: { id: 'blank-data-store', type: 'create-blank-data-store' },
        titles: [
          {
            type: HeadingType.H1,
            content: '<i class="fa-solid fa-plus primary-color-icon" style="color: var(--primary-color) !important;"></i>',

          },
          {
            type: HeadingType.H4,
            content: 'Create Data Store',

          }
        ],
        descriptions: [
          {
            content: 'Start with a clean slate and design your data store from scratch with full customization options',
            typography: {
              fontSize: 'var(--subtext-font-size)',
              whiteSpace: 'pre-wrap'
            }
          }
        ]
      },
      {
        data: { id: 'ai-data-store', type: 'create-ai-data-store' },
        titles: [
          {
            type: HeadingType.H1,
            content: '<i class="fa-solid fa-sparkles primary-color-icon" style="color: var(--primary-color) !important;"></i>',

          },
          {
            type: HeadingType.H4,
            content: 'Create Data Store with Assistant',

          }
        ],
        descriptions: [
          {
            content: 'Leverage AI to quickly generate a professional data store based on your requirements and specifications',
            typography: {
              fontSize: 'var(--subtext-font-size)',
              whiteSpace: 'pre-wrap'
            }
          }
        ],
        disabledCard: true,
        cardTooltipContent: 'Create Data Store with AI feature is not available for free plan users. Please upgrade your plan to use this feature.'
      }
    ],
    topCardsItemCountPerRow: ItemPerRow.Two,
  }
};

export const projectMembersCardsConfig: { cardsConfig: CardsConfig } = {
  cardsConfig: {
    itemCountPerRow: ItemPerRow.Two,
    showTitleOnImage: false,
    showDescriptionOnImage: false,
    showCheckMarkOnCard: false,
    paginationConfig: {
      pageIndex: 1,
      total: 3,
      pageSize: 6,
      showPagination: false,
      nzFrontPagination: false
    },
    selectConfig: {
      options: [],
      settings: {
        mode: SelectMode.Multiple,
        maxTagCount: 1
      },
      placeholder: 'Filter Members',
      visibility: false
    },
    items: [
      {
        type: 'project-members',
        data: { id: 'owners' },
        titles: [
          {
            type: HeadingType.H4,
            content: 'Owners',

          }
        ],
        image: {
          source: 'assets/img/page-templates/profile-template1-thumbnail.png'
        },
        imageTags: [{}]
      },
      {
        type: 'project-members',
        data: { id: 'managers' },
        titles: [
          {
            type: HeadingType.H4,
            content: 'Managers',

          }
        ],
        image: {
          source: 'assets/img/page-templates/profile-template1-thumbnail.png'
        },
        imageTags: [{}]
      },
      {
        type: 'project-members',
        data: { id: 'members' },
        titles: [
          {
            type: HeadingType.H4,
            content: 'Members',

          }
        ],
        image: {
          source: 'assets/img/page-templates/profile-template1-thumbnail.png'
        },
        imageTags: [{}]
      }
    ],
    inputGroupConfig: {
      textbox: {
        placeholder: 'Search in Project Members',
      },
      suffixIcon: {
        name: 'fas fa-xmark',
        isClickable: true,
        type: IconType.FontAwesome,
      }
    },
    topCards: [
      {
        data: { id: 'invite-user', type: 'invite-user' },
        titles: [
          {
            type: HeadingType.H1,
            content: '<i class="fa-solid fa-plus primary-color-icon" style="color: var(--primary-color) !important;"></i>',

          },
          {
            type: HeadingType.H4,
            content: 'Invite User',

          }
        ],
        descriptions: [
          {
            content: 'Invite new team members',
            typography: {
              fontSize: 'var(--subtext-font-size)',
              whiteSpace: 'pre-wrap'
            }
          }
        ],
        cardTooltipContent: 'Invite new team members to collaborate on your project with specific roles.',

      }
    ],
    topCardsItemCountPerRow: ItemPerRow.Two,
  }
};

export const shareApplicationCardsConfig: { cardsConfig: CardsConfig } = {
  cardsConfig: {
    itemCountPerRow: ItemPerRow.Two,
    showTitleOnImage: false,
    showDescriptionOnImage: false,
    showCheckMarkOnCard: false,
    paginationConfig: {
      pageIndex: 1,
      total: 3,
      pageSize: 6,
      showPagination: false,
      nzFrontPagination: false
    },
    selectConfig: {
      options: [],
      settings: {
        mode: SelectMode.Multiple,
        maxTagCount: 1
      },
      placeholder: 'Filter Share Application',
      visibility: false
    },
    items: [
      {
        type: 'share-application',
        data: { id: 'share-application-x' },
        titles: [
          {
            type: HeadingType.H1,
            content: '🔗'
          },
          {
            type: HeadingType.H4,
            content: 'Share Application on X',

          }
        ]
      },
      {
        type: 'share-application',
        data: { id: 'share-application-linkedin' },
        titles: [
          {
            type: HeadingType.H1,
            content: '🔗'
          },
          {
            type: HeadingType.H4,
            content: 'Share Application on LinkedIn',

          }
        ]
      }
    ],
    inputGroupConfig: {
      textbox: {
        placeholder: 'Search in Share Application',
      },
      suffixIcon: {
        name: 'fas fa-xmark',
        isClickable: true,
        type: IconType.FontAwesome,
      }
    },
    topCards: [
      {
        type: 'explore-rapider-studio',
        data: { id: 'explore-rapider-studio', type: 'explore-rapider-studio' },
        titles: [
          {
            type: HeadingType.H1,
            content: '🚀'
          },
          {
            type: HeadingType.H4,
            content: 'Explore Rapider Studio',

          }
        ],
        descriptions: [
          {
            content: 'Explore Rapider Studio',
            typography: {
              fontSize: 'var(--subtext-font-size)',
              whiteSpace: 'pre-wrap'
            }
          }
        ]
      }
    ],
    topCardsItemCountPerRow: ItemPerRow.Two,
  }
};

export const deployCardsConfig: { cardsConfig: CardsConfig } = {
  cardsConfig: {
    itemCountPerRow: ItemPerRow.Two,
    showTitleOnImage: false,
    showDescriptionOnImage: false,
    showCheckMarkOnCard: false,
    paginationConfig: {
      pageIndex: 1,
      total: 1,
      pageSize: 1,
      showPagination: false,
      nzFrontPagination: false
    },
    selectConfig: {
      options: [],
      settings: {
        mode: SelectMode.Multiple,
        maxTagCount: 1
      },
      placeholder: 'Filter Deploy',
      visibility: false
    },
    items: [],
    inputGroupConfig: {
      textbox: {
        placeholder: 'Search in Deploy',
      },
      suffixIcon: {
        name: 'fas fa-xmark',
        isClickable: true,
        type: IconType.FontAwesome,
      }
    },
    showSearchSection: false,
    topCards: [
      {
        type: 'deploy-project',
        data: { id: 'deploy-project', type: 'deploy-project' },
        titles: [
          {
            type: HeadingType.H1,
            content: '🚀'
          },
          {
            type: HeadingType.H4,
            content: 'Deploy Project',

          }
        ],
        descriptions: [
          {
            content: 'Deploy your project to the server and preview it live. Make sure to share your project on social media first to enable deployment.',
            typography: {
              fontSize: 'var(--subtext-font-size)',
              whiteSpace: 'pre-wrap'
            }
          }
        ]
      }
    ],
    topCardsItemCountPerRow: ItemPerRow.Two,
  }
};

export const serverCardsConfig: { cardsConfig: CardsConfig } = {
  cardsConfig: {
    itemCountPerRow: ItemPerRow.Two,
    showTitleOnImage: false,
    showDescriptionOnImage: false,
    showCheckMarkOnCard: false,
    paginationConfig: {
      pageIndex: 1,
      total: 1,
      pageSize: 1,
      showPagination: false,
      nzFrontPagination: false
    },
    selectConfig: {
      options: [],
      settings: {
        mode: SelectMode.Multiple,
        maxTagCount: 1
      },
      placeholder: 'Filter Server',
      visibility: false
    },
    items: [
      {
        type: 'server-toggle-power',
        data: { id: 'server-toggle-power', type: 'server-toggle-power' },
        titles: [
          {
            type: HeadingType.H4,
            content: 'Server Management'
          }
        ],
        descriptions: [
          {
            typography: {
              fontSize: 'var(--subtext-font-size)'
            },
            content: 'Server Status: Checking...'
          }
        ],
        isTooltipEnabledOnDescription: true,
        image: {
          source: 'assets/img/page-templates/profile-template1-thumbnail.png'
        },
        imageTags: [{}],
        borderSettings: {
          border: '1px solid var(--secondary-border-color)'
        },
        cardTooltipContent: 'Click to toggle server power state'
      }
    ],
    inputGroupConfig: {
      textbox: {
        placeholder: 'Search in Server',
      },
      suffixIcon: {
        name: 'fas fa-xmark',
        isClickable: true,
        type: IconType.FontAwesome,
      }
    },
    showSearchSection: false,
  }
};

export const serverSideBusinessProcessesCardsConfig: { cardsConfig: CardsConfig } = {
  cardsConfig: {
    itemCountPerRow: ItemPerRow.Two,
    showTitleOnImage: false,
    showDescriptionOnImage: false,
    showCheckMarkOnCard: false,
    paginationConfig: {
      pageIndex: 1,
      total: 3,
      pageSize: 6,
      showPagination: false,
      nzFrontPagination: false
    },
    selectConfig: {
      options: [],
      settings: {
        mode: SelectMode.Multiple,
        maxTagCount: 1
      },
      placeholder: 'Filter Tags',
      visibility: false
    },
    items: [],
    inputGroupConfig: {
      textbox: {
        placeholder: 'Search in Workflows',
      },
      suffixIcon: {
        name: 'fas fa-xmark',
        isClickable: true,
        type: IconType.FontAwesome,
      }
    },
    topCardsItemCountPerRow: ItemPerRow.Two,
  }
};

export const dataModelRelationsCardsConfig: { cardsConfig: CardsConfig } = {
  cardsConfig: {
    itemCountPerRow: ItemPerRow.Two,
    showTitleOnImage: false,
    showDescriptionOnImage: false,
    showCheckMarkOnCard: false,
    paginationConfig: {
      pageIndex: 1,
      total: 3,
      pageSize: 6,
      showPagination: false,
      nzFrontPagination: false
    },
    selectConfig: {
      options: [],
      settings: {
        mode: SelectMode.Multiple,
        maxTagCount: 1
      },
      placeholder: 'Filter Relations',
      visibility: false
    },
    items: [],
    inputGroupConfig: {
      textbox: {
        placeholder: 'Search in Data Relationships',
      },
      suffixIcon: {
        name: 'fas fa-xmark',
        type: IconType.FontAwesome,
        isClickable: true
      }
    }
  }
};
